import DOMPurify from 'dompurify'

import { ALLOWED_TAGS } from './markdown-tags'

export function sanitizeMarkdown(raw: string): string {
  const fragment = DOMPurify.sanitize(raw, {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ['href', 'title', 'rel', 'target', 'class'],
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false,
    RETURN_DOM_FRAGMENT: true,
  })
  // Keep attributes scoped to the same elements as the original allowlist.
  for (const element of fragment.querySelectorAll('*')) {
    const allowed =
      element.tagName === 'A'
        ? ['href', 'title', 'rel', 'target']
        : ['CODE', 'SPAN'].includes(element.tagName)
          ? ['class']
          : []
    for (const attribute of Array.from(element.attributes)) {
      if (!allowed.includes(attribute.name)) {
        element.removeAttribute(attribute.name)
      }
    }
    if (element.tagName === 'A') {
      element.setAttribute('rel', 'noopener noreferrer')
      element.setAttribute('target', '_blank')
    }
  }
  const container = document.createElement('div')
  container.append(fragment)
  return container.innerHTML
}

export function sanitizeText(html: string): string {
  const fragment = DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR: [], RETURN_DOM_FRAGMENT: true })
  return (fragment.textContent ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
}
